import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import LiveDemo from './components/LiveDemo';
import Contact from './components/Contact';
import Footer from './components/Footer';

const HomePage = () => (
  <main>
    <Hero />
    <About />
    <Projects />
    <LiveDemo />
    <Contact />
  </main>
);

const ProjectsPage = () => (
  <main>
    <Projects />
    <LiveDemo />
  </main>
);

const ContactPage = () => (
  <main>
    <Contact />
  </main>
);

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
